import { createRoute, redirect } from "@tanstack/react-router";

import { authLayoutRoute } from "../auth-layout/route";
import { ticketsRoute } from "../tickets/route";

export const indexRoute = createRoute({
  getParentRoute: () => authLayoutRoute,
  path: "/",
  beforeLoad() {
    throw redirect({
      to: ticketsRoute.to,
    });
  },
});
